import { Clock, Download, Shield, Trophy } from "lucide-react";
import { useEffect, useState } from "react";
import heroimagerich from "../../../RichImages/new_hero_section_img.png";
import { FaWhatsapp } from "react-icons/fa";

import { downloadAPK } from "../../Helpers/DownloadAPK";
import { GET_CONTACT } from "../../service/admin.service";

const Section2 = () => {
  const [getData, setgetData] = useState([]);
  const getResponseData = async () => {
    const res = await GET_CONTACT();
    setgetData(res.data[0]);
  };

  useEffect(() => {
    getResponseData();
  }, []);

const download = async (e) => {
  e.preventDefault();

  const newTab = window.open("about:blank", "_blank");

  if (!newTab) {
    alert("Popup blocked! Please allow popups.");
    return;
  }

  // Only favicon loader (tab ke upar spinner)
  const loaderIcon =
    "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><circle cx='50' cy='50' r='40' stroke='%23999' stroke-width='8' fill='none' stroke-dasharray='180'><animateTransform attributeName='transform' type='rotate' from='0 50 50' to='360 50 50' dur='1s' repeatCount='indefinite'/></circle></svg>";

  try {
    // Empty page
    newTab.document.open();
    newTab.document.write("<html><head></head><body></body></html>");
    newTab.document.close();

    // Set favicon (THIS IS YOUR “EARTH ICON LOADER”)
    const link = newTab.document.createElement("link");
    link.rel = "icon";
    link.href = loaderIcon;
    newTab.document.head.appendChild(link);

    newTab.document.title = "Loading...";

    const url = await downloadAPK();

    if (!url) {
      newTab.close();
      return;
    }

    // start download (no redirect flicker)
    const a = document.createElement("a");
    a.href = url;
    a.download = "boss555.apk";
    document.body.appendChild(a);
    a.click();
    a.remove();

    setTimeout(() => {
      newTab.close();
    }, 1500);
  } catch (err) {
    newTab.close();
    console.error(err);
  }
};

  return (
    <div>
      {/* ===== Desktop ONLY ===== */}
      <div className="tw-min-h-screen tw-bg-[#1e6ebe] tw-py-8 lg:tw-block tw-hidden">
        <div className="md:tw-px-8 lg:tw-px-12 lg:tw-mt-10 tw-mt-0">
          <div className="tw-grid tw-grid-cols-12">
            <div className="lg:tw-col-span-6 tw-col-span-12 tw-text-white tw-space-y-6 md:tw-space-y-8 lg:tw-pt-14 tw-pt-14">
              <div>
                <p className="tw-inline-block tw-bg-white/15 tw-text-[#EFFFFD] tw-text-[16px] tw-tw-font-semibold tw-tracking-widest tw-uppercase tw-px-4 tw-py-1.5 tw-rounded-full tw-containermb-4">
                  Welcome To Laksh365
                </p>
                <h1 className="tw-text-3xl tw-mt-2 md:tw-text-3xl lg:tw-text-4xl xl:tw-text-5xl tw-font-bold tw-leading-tight tw-capitalize">
                  india's Most <br />
                  trusted{" "}
                  <span className="tw-text-yellow-400">
                    <br />
                    Matka <br />
                    Application
                  </span>
                </h1>
                {/* Welcome Bonus */}
                {/* <h2 className="tw-text-3xl md:tw-text-4xl lg:tw-text-5xl tw-font-bold tw-text-yellow-400 tw-mt-5 tw-italic tw-animate-pulse">
                  Free ₹100/-
                </h2>

                <h3 className="tw-text-2xl tw-font-semibold tw-text-white tw-animate-pulse">
                  Welcome Bonus
                </h3> */}
              </div>

              <p className="tw-text-sm md:tw-text-base lg:tw-text-lg tw-font-semibold tw-max-w-xl tw-capitalize">
                play matka safety with real-time updates and instant payouts.
                best market rates
              </p>

              <div className="tw-flex tw-flex-wrap tw-gap-4">
                <style>{`
  @keyframes floatBounce {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-6px); }
  }

  .float-btn {
    animation: floatBounce 2.5s ease-in-out infinite;
    transition: all 0.3s ease;
  }

  .float-btn:hover {
    transform: scale(1.05);
    box-shadow: 0 0 20px rgba(0,0,0,0.25);
    animation-play-state: paused;
  }
                      `}</style>

                {/* Download Button */}
                <button
                  onClick={download}
                  className="float-btn
               tw-relative tw-overflow-hidden
               tw-bg-yellow-400 hover:tw-bg-yellow-500
               tw-text-gray-900 tw-font-semibold
               tw-px-6 tw-py-3 tw-rounded-2xl
               tw-flex tw-items-center tw-gap-2
               tw-shadow-xl
               tw-transition-all tw-duration-300"
                >
                  <Download className="tw-w-5 tw-h-5 tw-animate-bounce" />
                  Download App
                </button>

                {/* WhatsApp Support */}
                <a
                  href={`https://wa.me/${getData && getData.whatsAppNumber}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="float-btn
               tw-bg-gradient-to-r tw-from-[#1e6ebe] tw-to-[#2aa9ff]
               tw-text-white tw-font-semibold
               tw-px-6 tw-py-3 tw-rounded-2xl
               tw-flex tw-items-center tw-gap-2
               tw-no-underline
               tw-shadow-xl
               tw-transition-all tw-duration-300"
                >
                  <FaWhatsapp className="tw-w-5 tw-h-5 tw-animate-bounce" />
                  WhatsApp Support
                </a>
              </div>

              <div className="tw-hidden lg:tw-grid tw-grid-cols-3 tw-gap-6 tw-pt-16">
                <div className="tw-space-y-2">
                  <div className="tw-w-12 tw-h-12 tw-bg-[#1e6ebe] tw-bg-opacity-50 tw-rounded-lg tw-flex tw-items-center tw-justify-center">
                    <Shield className="tw-w-6 tw-h-6 tw-text-white" />
                  </div>
                  <h3 className=" tw-text-base lg:tw-text-lg">100% Secure</h3>
                  <p className="tw-text-xs lg:tw-text-sm tw-text-teal-100">
                    Safe Payments
                  </p>
                </div>

                <div className="tw-space-y-2">
                  <div className="tw-w-12 tw-h-12 tw-bg-[#1e6ebe] tw-bg-opacity-50 tw-rounded-lg tw-flex tw-items-center tw-justify-center">
                    <Clock className="tw-w-6 tw-h-6 tw-text-white" />
                  </div>
                  <h3 className=" tw-text-base lg:tw-text-lg">
                    Instant Payouts
                  </h3>
                  <p className="tw-text-xs lg:tw-text-sm tw-text-teal-100">
                    Within Minutes
                  </p>
                </div>

                <div className="tw-space-y-2">
                  <div className="tw-w-12 tw-h-12 tw-bg-[#1e6ebe] tw-bg-opacity-50 tw-rounded-lg tw-flex tw-items-center tw-justify-center">
                    <Trophy className="tw-w-6 tw-h-6 tw-text-white" />
                  </div>
                  <h3 className=" tw-text-base lg:tw-text-lg">Best Rates</h3>
                  <p className="tw-text-xs lg:tw-text-sm tw-text-teal-100">
                    Guaranteed
                  </p>
                </div>
              </div>
            </div>

            <div className="tw-col-span-6 tw-relative tw-flex tw-justify-center lg:tw-justify-end lg:tw-pt-14 tw-pt-0">
              <div className="tw-relative tw-w-full tw-max-w-md lg:tw-max-w-lg">
                <img
                  src={heroimagerich}
                  alt="Laksh365 Matka Application"
                  className="tw-w-full tw-h-auto tw-object-contain tw-drop-shadow-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ===== Mobile ONLY ===== */}
      <div className="pb-2 tw-bg-[#1e6ebe] tw-pt-2 tw-block lg:tw-hidden tw-mt-12">
        <div className="tw-px-4 md:tw-px-6">
          <div className="pt-3">
            <div className="tw-space-y-2">
              <div className="">
                <p className="tw-inline-block tw-bg-white/15 tw-text-[#EFFFFD] tw-text-[12px] tw-tw-font-semibold tw-tracking-widest tw-uppercase tw-px-2 tw-py-1 tw-rounded-full tw-containermb-4">
                  Welcome To Laksh365
                </p>
                <h1 className="tw-text-lg tw-mt-2 tw-text-white md:tw-text-3xl lg:tw-text-4xl xl:tw-text-5xl tw-font-bold tw-leading-tight tw-capitalize">
                  india's Most trusted{" "}
                  <span className="tw-text-yellow-400">Matka Application</span>
                </h1>
                {/* Welcome Bonus Mobile */}
                {/* <div className="tw-mt-2">
                  <h2 className="tw-text-lg tw-font-bold tw-text-yellow-400 tw-italic tw-animate-pulse">
                    Free ₹100/-
                  </h2>
                  <h3 className="tw-text-[12px] tw-font-semibold tw-text-white tw-animate-pulse">
                    Welcome Bonus
                  </h3>
                  
                </div> */}
              </div>
              <p className="tw-text-[10px] tw-text-white tw-text-opacity-90 ">
                play matka safety with real-time updates and instant payouts.
                best market rates
              </p>
            </div>
          </div>

          {/* Image below content */}
          <div className=" tw-w-full tw-max-w-md tw-mx-auto">
            <img
              src={heroimagerich}
              alt="Laksh365 Matka Application"
              className="tw-w-full tw-h-auto tw-object-contain tw-drop-shadow-2xl"
            />
          </div>

          <div className="tw-flex tw-flex-col tw-gap-3">
            <style>{`
    @keyframes floatBounce {
      0%, 100% { transform: translateY(0px); }
      50% { transform: translateY(-6px); }
    }

    .float-btn {
      animation: floatBounce 2.5s ease-in-out infinite;
      transition: all 0.3s ease;
    }

    .float-btn:hover {
      transform: scale(1.05);
      box-shadow: 0 0 20px rgba(0,0,0,0.25);
      animation-play-state: paused;
    }
  `}</style>

            {/* Download Button */}
            <button
              onClick={download}
              className="float-btn
      tw-bg-yellow-400 hover:tw-bg-yellow-500
      tw-text-gray-900 tw-font-semibold
      tw-px-6 tw-py-3 tw-rounded-2xl
      tw-flex tw-items-center tw-justify-center tw-gap-2
      tw-shadow-xl tw-transition-all tw-duration-300 "
            >
              <Download className="tw-w-5 tw-h-5 tw-animate-bounce" />
              Download App
            </button>

            {/* WhatsApp Button */}
            <a
              href={`https://wa.me/${getData?.whatsAppNumber}`}
              className="float-btn
      tw-bg-gradient-to-r tw-from-[#1e6ebe] tw-to-[#2aa9ff]
      tw-text-white tw-font-semibold
      tw-px-6 tw-py-3 tw-rounded-2xl
      tw-flex tw-items-center tw-justify-center tw-gap-2
      tw-no-underline
      tw-shadow-xl tw-transition-all tw-duration-300"
            >
              <FaWhatsapp className="tw-w-5 tw-h-5 tw-animate-bounce" />
              Whats App Support
            </a>
          </div>

          {/* Features mobile */}
          {/* <div className="tw-grid tw-grid-cols-3 tw-gap-4 tw-mt-6">
            <div className="tw-bg-white tw-bg-opacity-10 tw-rounded-2xl tw-p-3 tw-text-center">
              <Shield className="tw-w-5 tw-h-5 tw-text-white tw-mx-auto" />
              <p className="tw-text-white tw-font-semibold tw-text-sm tw-mt-2">
                Secure
              </p>
            </div>
            <div className="tw-bg-white tw-bg-opacity-10 tw-rounded-2xl tw-p-3 tw-text-center">
              <Clock className="tw-w-5 tw-h-5 tw-text-white tw-mx-auto" />
              <p className="tw-text-white tw-font-semibold tw-text-sm tw-mt-2">
                Instant
              </p>
            </div>
            <div className="tw-bg-white tw-bg-opacity-10 tw-rounded-2xl tw-p-3 tw-text-center">
              <Trophy className="tw-w-5 tw-h-5 tw-text-white tw-mx-auto" />
              <p className="tw-text-white tw-font-semibold tw-text-sm tw-mt-2">
                Best Rates
              </p>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Section2;
